document.addEventListener('DOMContentLoaded', function(){
  var mega_menu_list = document.querySelectorAll('details.mega-menu'), menu_outer = document.querySelector('.header__inline-menu');
  if(mega_menu_list.length > 0){
    mega_menu_list.forEach(function(item){
      item.addEventListener('mouseenter',function(e){
        e.preventDefault();
        mega_menu_list.forEach(function(link){
          link.removeAttribute('open');
          link.querySelector('summary').setAttribute('aria-expanded','false');
        })
        this.setAttribute('open','');
        this.querySelector('summary').setAttribute('aria-expanded','true');
      })
    })
  }
  if(menu_outer){
    menu_outer.addEventListener('mouseleave',function(e){
      e.preventDefault();
      mega_menu_list.forEach(function(item){
        item.removeAttribute('open');
        item.querySelector('summary').setAttribute('aria-expanded','false');
      })
    })
  }
})